import AdminLayout from "../../../components/admin/layout/AdminLayout";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import ViewBids from "../../../components/common/bid/ViewBids";

function ViewBidsPage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <ViewBids />
    </AdminLayout>
  );
}

export default ViewBidsPage;
